import { useEffect, useMemo } from "react"
import { InputAdornment, Box } from "@mui/material"

import useInput from "hooks/use_input"
import useTranslation from "hooks/use_translation"
import useAppStore from "store/app"
import countries from "config/countries"

import BaseMask from "components/base/Mask"
import BaseTextField from "components/base/TextField"
import CountryCode from "./CountryCode"

const PhoneNumber = () => {
  const id = "phone_number"

  const country_code = useAppStore((state) => state.fields.country_code.input_value)

  const updateFieldInputValue = useAppStore((state) => state.updateFieldInputValue)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)

  const { fields } = useTranslation()

  const validate = (value) => {
    if (value === "") return fields?.required

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  const currentCountry = useMemo(
    () => countries.find((c) => c.code === country_code),
    [country_code],
  )

  useEffect(() => {
    updateFieldInputValue(id, "")
    updateFieldErrorMessage(id, "")
  }, [country_code])

  return (
    <Box sx={{ display: "flex", alignItems: "baseline", justifyItems: "center", gap: 1 }}>
      <CountryCode />

      <BaseTextField
        dir="ltr"
        id={id}
        _label={fields?.phone_number_title}
        value={inputValue}
        onChange={handleChange}
        error={errorMessage?.length > 0}
        onBlur={handleBlur}
        helperText={errorMessage}
        InputProps={{
          startAdornment: <InputAdornment position="start">{country_code}</InputAdornment>,
          inputComponent: BaseMask,
          inputProps: {
            mask: currentCountry.mask,
          },
        }}
      />
    </Box>
  )
}

export default PhoneNumber
